export const invertedColors = {
  background: ['rgb(255, 255, 255)', 'rgb(41, 41, 41)'],
  border: ['rgba(17, 17, 17, 0.1)', 'rgba(255, 255, 255, 0.1)']
};
